import { Icon, IconProps } from '@chakra-ui/react';
import React from 'react';

export const LockIcon = (props: IconProps) => {
  return (
    <Icon {...props} viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.14961 4.5999H7.79961V3.5499C7.79961 1.8132 6.38631 0.399902 4.64961 0.399902C2.91291 0.399902 1.49961 1.8132 1.49961 3.5499V4.5999H1.14961C0.570709 4.5999 0.0996094 5.071 0.0996094 5.6499V11.2499C0.0996094 11.8288 0.570709 12.2999 1.14961 12.2999H8.14961C8.72851 12.2999 9.19961 11.8288 9.19961 11.2499V5.6499C9.19961 5.071 8.72851 4.5999 8.14961 4.5999ZM2.19961 3.5499C2.19961 2.1989 3.29861 1.0999 4.64961 1.0999C6.00061 1.0999 7.09961 2.1989 7.09961 3.5499V4.5999H2.19961V3.5499ZM8.49961 11.2499C8.49961 11.4431 8.34281 11.5999 8.14961 11.5999H1.14961C0.956409 11.5999 0.799609 11.4431 0.799609 11.2499V5.6499C0.799609 5.4567 0.956409 5.2999 1.14961 5.2999H8.14961C8.34281 5.2999 8.49961 5.4567 8.49961 5.6499V11.2499Z"
        fill="currentColor"
      />
    </Icon>
  );
};
